module.exports = __webpack_public_path__ + "static/media/avatar2.af9e253a.png";